module.exports = require('./helpers/bundle-url').getBundleURL('fUmN8') + "logo.c51670a8.svg";